export default "__VITE_ASSET__CyqZD$Uy__"